import { Add, Clear } from "@material-ui/icons";
import Image from "next/image";

const UploadedFilesList = ({
  uploads,
  setSelected,
  onAddFile = null,
  onRemoveFile = null,
  selectedIndex = 0,
  maxFiles = 5,
}) => {
  if (!uploads.length) {
    return null;
  }

  return (
    <div className="uploaded-files-list d-flex justify-content-center mt-3">
      {uploads.map((upload, index) => {
        return (
          <div
            key={index}
            className={`uploaded-item position-relative me-2 ${
              selectedIndex === index ? "selected" : ""
            }`}
            onClick={selectedIndex === index ? null : () => setSelected(index)}>
            {onRemoveFile ? (
              <span
                className="delete-upload"
                onClick={() => onRemoveFile(upload.url)}>
                <Clear />
              </span>
            ) : null}
            <Image
              src={upload.url}
              width={60}
              height={35}
              objectFit="cover"
              unoptimized
            />
          </div>
        );
      })}

      {onAddFile && uploads.length < maxFiles ? (
        <div
          className="add-item uploaded-item d-flex align-items-center justify-content-center"
          onClick={onAddFile}>
          <Add />
        </div>
      ) : null}
    </div>
  );
};

export default UploadedFilesList;
